import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated, selectUser, selectLoading } from '../redux/slices/authSlice';
import { Box, CircularProgress } from '@mui/material';

const RoleBasedRoute = ({ allowedRoles = [], redirectTo = '/login' }) => {
  const location = useLocation();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const user = useSelector(selectUser);
  const loading = useSelector(selectLoading);

  if (loading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <CircularProgress />
      </Box>
    );
  }

  // Not authenticated - redirect to login with return URL
  if (!isAuthenticated) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Agar allowedRoles empty hai to kisi bhi authenticated user ko allow karo
  if (allowedRoles.length === 0) {
    return <Outlet />;
  }

  // Check if user has required role
  if (!allowedRoles.includes(user?.role)) {
    // Redirect based on role
    if (user?.role === 'OWNER') {
      return <Navigate to="/owner/dashboard" replace />;
    } else if (user?.role === 'MANAGER' || user?.role === 'CASHIER' || user?.role === 'STAFF' || user?.role === 'KITCHEN') {
      return <Navigate to="/owner/dashboard" replace />; // Sabko same dashboard par bhejo
    }
    return <Navigate to="/" replace />;
  }

  // All good - render the protected content
  return <Outlet />;
};

export default RoleBasedRoute;
